import {
  Grid,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  CardMedia,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Check from "@mui/icons-material/Check";
import React, { memo, useEffect, useState } from "react";

const SummaryAccordion = (props) => {
  const {
    page,
    url,
    lang,
    multiBtn,
    title,
    data,
    edited,
    checkIcon,
    image,
    closePnl,
  } = props;
  const [expanded, setExpanded] = useState(page);

  const handleEdit = (e) => {
    props.changePage(e.target.value);
  };
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
    props.changeClose(panel);
  };

  useEffect(() => {
    if (edited === page) {
      handleChange(edited);
    } else {
      setExpanded(false);
    }
  }, []);

  return (
    <>
      <Accordion
        className="none-border-shadow mt-5 mb-5"
        expanded={expanded === page && page === (closePnl || edited)}
        onChange={handleChange(page)}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon color={"primary"} />}>
          <Grid>
            <Typography className="text-primary font-weight-bold font-20">
              {title}
            </Typography>
          </Grid>
        </AccordionSummary>
        {(page === "snapidcard" ||
          page === "address" ||
          page === "career" ||
          page === "invest_income" ||
          page === "invest_purpose" ||
          page === "invest_asset" ||
          page === "attach_sign" ||
          page === "house_registration"
        ) &&
          data.map(({ title, text, urls, checked }, i) => (
            <AccordionDetails className="pd-0 color-black" key={i}>
              <Grid className="font-DBHeavent font-16 font-normal mt-3 text-balck-2">
                {title}
                {page === "snapidcard" && (
                  <span style={{ textDecoration: "Underline" }}>ด้านหน้า</span>
                )}
              </Grid>
              {image ? (
                <Grid>
                  <Grid
                    className="image-snap-card"
                    style={{
                      backgroundImage: "url(" + text + ")",
                    }}
                  >
                    <Grid className="box-image-summary"></Grid>
                  </Grid>
                  <Grid>
                    <CardMedia
                      style={{
                        display: text ? "block" : "none",
                      }}
                      component="img"
                      className="icon-photo-water-summary"
                      image="../../images/waterMark2.png?v=4"
                      alt="photo"
                    />
                  </Grid>
                </Grid>
              ) : (
                <Grid className="font-DBHeavent font-20 font-normal text-black">
                  {checked && checkIcon && <Check className="text-primary" />}
                  {text}
                </Grid>
              )}
              <Grid>
                {multiBtn && (
                  <Grid className="btn-box mt-10">
                    <Button
                      className="btn-left btn-next font-20"
                      value={urls}
                      onClick={handleEdit}
                    >
                      {lang === "th" ? "แก้ไข" : "Edit"}
                    </Button>
                  </Grid>
                )}
              </Grid>
            </AccordionDetails>
          ))}
        {page === "status" &&
          data.map((e, i) => (
            <AccordionDetails className="pd-0 color-black" key={i}>
              <Grid className="font-DBHeavent font-16 font-normal mt-2 text-balck-2">
                สถานภาพการสมรส
              </Grid>
              <Grid className="font-DBHeavent font-20 font-normal text-black">
                {e.text_status}
              </Grid>

              <Grid className="font-DBHeavent font-20 font-weight-bold mt-3 text-black">
                {e.tile_spouse_is_th}
              </Grid>

              <Grid className="font-DBHeavent font-16 font-normal mt-5 text-balck-2">
                {e.title_idc}
              </Grid>
              <Grid className="font-DBHeavent font-20 font-normal text-black">
                {e.text_idc}
              </Grid>

              <Grid className="font-DBHeavent font-16 font-normal mt-5 text-balck-2">
                {e.title_name_title}
              </Grid>
              <Grid className="font-DBHeavent font-20 font-normal text-black">
                {e.text_name_title}
              </Grid>

              <Grid className="font-DBHeavent font-16 font-normal mt-5 text-balck-2">
                {e.title_fname_th}
              </Grid>
              <Grid className="font-DBHeavent font-20 font-normal text-black">
                {e.text_fname_th}
              </Grid>

              <Grid className="font-DBHeavent font-16 font-normal mt-5 text-balck-2">
                {e.title_lname_th}
              </Grid>
              <Grid className="font-DBHeavent font-20 font-normal text-black">
                {e.text_lname_th}
              </Grid>

              <Grid className="font-DBHeavent font-16 font-normal mt-5 text-balck-2">
                {e.title_fname_en}
              </Grid>
              <Grid className="font-DBHeavent font-20 font-normal text-black">
                {e.text_fname_en}
              </Grid>

              <Grid className="font-DBHeavent font-16 font-normal mt-5 text-balck-2">
                {e.title_lname_en}
              </Grid>
              <Grid className="font-DBHeavent font-20 font-normal text-black">
                {e.text_lname_en}
              </Grid>
            </AccordionDetails>
          ))}
        {page === "childList" &&
          data.map((e, i) => (
            <AccordionDetails className="pd-0 color-black" key={i}>
              {i === 0 && (
                <Grid className="font-DBHeavent font-20 font-normal mt-0 text-black">
                  {e.isHave}
                </Grid>
              )}
              <Grid className="font-DBHeavent font-20 font-weight-bold mt-3 text-black">
                {e.title}
              </Grid>
              <Grid className="font-DBHeavent font-16 font-normal mt-5 text-balck-2">
                {e.title_idc}
              </Grid>
              <Grid className="font-DBHeavent font-20 font-normal text-black">
                {e.text_idc}
              </Grid>
              <Grid className="font-DBHeavent font-16 font-normal mt-5 text-balck-2">
                {e.title_fname}
              </Grid>
              <Grid className="font-DBHeavent font-20 font-normal text-black">
                {e.text_fname}
              </Grid>

              <Grid className="font-DBHeavent font-16 font-normal mt-5 text-balck-2">
                {e.title_lname}
              </Grid>
              <Grid className="font-DBHeavent font-20 font-normal text-black">
                {e.text_lname}
              </Grid>

              <Grid className="font-DBHeavent font-16 font-normal mt-5 text-balck-2">
                {e.title_bd}
              </Grid>
              <Grid className="font-DBHeavent font-20 font-normal text-black">
                {e.text_bd}
              </Grid>
            </AccordionDetails>
          ))}
        {page === "product_choice" &&
          data.map((e, i) => (
            <AccordionDetails className="pd-0 color-black" key={i}>
              <Grid
                className="font-DBHeavent font-20 font-weight-bold mt-3 text-black"
                style={{
                  display: e.items?.find((i) => i.selected === 1) ? "" : "none",
                }}
              >
                {e.group}
              </Grid>
              {e.items.map((item, id) => (
                <Grid key={id}>
                  {item.selected === 1 && (
                    <Grid className="font-DBHeavent font-20 font-normal text-black">
                      <Check className="text-primary" />
                      {item.name}
                    </Grid>
                  )}
                </Grid>
              ))}
            </AccordionDetails>
          ))}
        {page === "idc" &&
          data.map((e, i) => (
            <AccordionDetails className="pd-0 color-black" key={i}>
              <Grid className="font-DBHeavent font-16 font-normal mt-2 text-balck-2">
                หมายเลขบัตรประจำตัวประชาชน
              </Grid>
              <Grid className="font-DBHeavent font-20 font-normal text-black">
                {e.idc}
              </Grid>

              <Grid className="font-DBHeavent font-16 font-normal mt-5 text-balck-2">
                หมายเลขเลเซอร์หลังบัตรประจำตัวประชาชน
              </Grid>
              <Grid className="font-DBHeavent font-20 font-normal text-black">
                {e.backIdc}
              </Grid>

              <Grid className="font-DBHeavent font-16 font-normal mt-5 text-balck-2">
                วันหมดอายุ (ค.ศ.)
              </Grid>
              <Grid className="font-DBHeavent font-20 font-normal text-black">
                {e.exp}
              </Grid>

              <Grid className="font-DBHeavent font-16 font-normal mt-5 text-balck-2">
                คำนำหน้าชื่อ
              </Grid>
              <Grid className="font-DBHeavent font-20 font-normal text-black">
                {e.nameTitle}
              </Grid>

              <Grid className="font-DBHeavent font-16 font-normal mt-5 text-balck-2">
                ชื่อ (ภาษาไทย)
              </Grid>
              <Grid className="font-DBHeavent font-20 font-normal text-black">
                {e.fnameTh}
              </Grid>

              <Grid className="font-DBHeavent font-16 font-normal mt-5 text-balck-2">
                ชื่อกลาง (ภาษาไทย)
              </Grid>
              <Grid className="font-DBHeavent font-20 font-normal text-black">
                {e.midNameTh}
              </Grid>

              <Grid className="font-DBHeavent font-16 font-normal mt-5 text-balck-2">
                นามสกุล (ภาษาไทย)
              </Grid>
              <Grid className="font-DBHeavent font-20 font-normal text-black">
                {e.lnameTh}
              </Grid>

              <Grid className="font-DBHeavent font-16 font-normal mt-5 text-balck-2">
                ชื่อ (ภาษาอังกฤษ)
              </Grid>
              <Grid className="font-DBHeavent font-20 font-normal text-black">
                {e.fnameEn}
              </Grid>

              <Grid className="font-DBHeavent font-16 font-normal mt-5 text-balck-2">
                ชื่อกลาง (ภาษาอังกฤษ)
              </Grid>
              <Grid className="font-DBHeavent font-20 font-normal text-black">
                {e.midNameEn}
              </Grid>

              <Grid className="font-DBHeavent font-16 font-normal mt-5 text-balck-2">
                นามสกุล (ภาษาอังกฤษ)
              </Grid>
              <Grid className="font-DBHeavent font-20 font-normal text-black">
                {e.lnameEn}
              </Grid>

              <Grid className="font-DBHeavent font-16 font-normal mt-5 text-balck-2">
                ประเทศเจ้าของสัญชาติ
              </Grid>
              <Grid className="font-DBHeavent font-20 font-normal text-black">
                {e.nationality}
              </Grid>

              <Grid className="font-DBHeavent font-16 font-normal mt-5 text-balck-2">
                วันเดือนปี (ค.ศ.) เกิด
              </Grid>
              <Grid className="font-DBHeavent font-20 font-normal text-black">
                {e.bd}
              </Grid>

              <Grid className="font-DBHeavent font-16 font-normal mt-5 text-balck-2">
                เบอร์โทรศัพท์มือถือ
              </Grid>
              <Grid className="font-DBHeavent font-20 font-normal text-black">
                {e.phone}
              </Grid>

              <Grid className="font-DBHeavent font-16 font-normal mt-5 text-balck-2">
                อีเมล
              </Grid>
              <Grid className="font-DBHeavent font-20 font-normal text-black">
                {e.email}
              </Grid>

              <Grid
                className="font-DBHeavent font-16 font-weight-bold mt-5"
                style={{ color: "red" }}
              >
                *หมายเหตุ บริษัทจะจัดส่งเอกสารทางอีเมลนี้
              </Grid>
            </AccordionDetails>
          ))}
        {page === "crsBirthAddress" && data.map((e, i) => (
          <AccordionDetails className="pd-0 color-black" key={i}>
            <Grid className="font-DBHeavent font-16 font-normal mt-5 text-balck-2">
              {e.countryTitle}
            </Grid>
            <Grid className="font-DBHeavent font-20 font-normal text-black">
              {e.countryText}
            </Grid>
            {
              e.provinceText && (
                <>
                  <Grid className="font-DBHeavent font-16 font-normal mt-5 text-balck-2">
                    {e.provinceTitle}
                  </Grid>
                  <Grid className="font-DBHeavent font-20 font-normal text-black">
                    {e.provinceText}
                  </Grid>
                </>
              )
            }
            {
              e.birthCityText && (
                <>
                  <Grid className="font-DBHeavent font-16 font-normal mt-5 text-balck-2">
                    {e.birthCityTitle}
                  </Grid>
                  <Grid className="font-DBHeavent font-20 font-normal text-black">
                    {e.birthCityText}
                  </Grid>
                </>
              )
            }
          </AccordionDetails>
        ))}
        {page === "crsDeclareLocation" && data.map((e, i) => (
          <AccordionDetails className="pd-0 color-black" key={i}>
            <Grid className="font-DBHeavent font-16 font-normal mt-5 text-balck-2">
              {e.countryTitle}
            </Grid>
            <Grid className="font-DBHeavent font-20 font-normal text-black">
              {e.countryText}
            </Grid>
            <Grid className="font-DBHeavent font-16 font-normal text-balck-2">
              {e.descriptionTitle}
            </Grid>
            <Grid className="font-DBHeavent font-20 font-normal text-black">
              {e.descriptionText}
            </Grid>
          </AccordionDetails>
        ))}
        {page === "ats" &&
          data.map((e, i) => (
            <AccordionDetails className="pd-0 color-black" key={i}>
              <Grid className="font-DBHeavent font-16 font-normal mt-5 text-balck-2">
                ชื่อบัญชี
              </Grid>
              <Grid className="font-DBHeavent font-20 font-normal text-black">
                {e.accName}
              </Grid>

              <Grid className="font-DBHeavent font-16 font-normal mt-5 text-balck-2">
                เลขที่บัญชี
              </Grid>
              <Grid className="font-DBHeavent font-20 font-normal text-black">
                {e.accNo}
              </Grid>

              <Grid className="font-DBHeavent font-16 font-normal mt-5 text-balck-2">
                ธนาคาร
              </Grid>
              <Grid className="font-DBHeavent font-20 font-normal text-black">
                {e.bankName}
              </Grid>

              {e.uploadImageBookBank ? (
                <Grid>
                  <Grid
                    className="image-snap-card"
                    style={{
                      backgroundImage: "url(" + e.uploadImageBookBank + ")",
                    }}
                  >
                    <Grid className="box-image-summary"></Grid>
                  </Grid>
                  <Grid>
                    <CardMedia
                      style={{
                        display: e.uploadImageBookBank ? "block" : "none",
                      }}
                      component="img"
                      className="icon-photo-water-summary"
                      image="../../images/waterMark2.png?v=4"
                      alt="photo"
                    />
                  </Grid>
                </Grid>
              ) : (
                ""
              )}

              {e.other === "1" && (
                <Grid className="font-DBHeavent font-16 font-weight-bold mt-5 text-black">
                  กรุณาดำเนินการสมัครบริการหักบัญชีอัตโนมัติ (ATS)
                  เพื่อความสะดวกในการทำธุรกรรม ท่านจะได้รับขั้นตอนการสมัคร
                  หลังจากยืนยันข้อมูลการเปิดบัญชีในขั้นตอนถัดไปผ่านอีเมลที่ท่านให้ไว้
                </Grid>
              )}
            </AccordionDetails>
          ))}
        <Grid>
          {page !== "idc" &&
            page !== "ats" &&
            page !== "address" &&
            page !== "product_choice" && (
              <Grid className="btn-box mt-10">
                <Button
                  className="btn-left btn-next font-20"
                  value={url}
                  onClick={handleEdit}
                >
                  {lang === "th" ? "แก้ไข" : "Edit"}
                </Button>
              </Grid>
            )}
        </Grid>
      </Accordion>
      <Grid className="line-gray"></Grid>
    </>
  );
};

export default memo(SummaryAccordion);
